/**
 * 広告が画面を覆っているあいだ、ゲームの音を止めるための合図。
 *
 * AdMob の広告はアプリの画面の上に別の画面として出るので、WebView 側からは「隠れた」ことが分からない
 * （visibilitychange も来ない）。広告の動画とゲームのBGMが重なって鳴らないように、
 * NativePlatform が出す前後に知らせる。
 */

type Listener = (covering: boolean) => void;
const listeners = new Set<Listener>();

export function onAdCovering(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

type UnavailableListener = () => void;
const unavailableListeners = new Set<UnavailableListener>();

/** ごほうび広告を押したのに出せなかった（読み込めていない・出すのに失敗した）とき。画面で「今は読み込めません」を出す。 */
export function onAdUnavailable(listener: UnavailableListener): () => void {
  unavailableListeners.add(listener);
  return () => unavailableListeners.delete(listener);
}

export function notifyAdUnavailable(): void {
  unavailableListeners.forEach((l) => {
    try {
      l();
    } catch {
      /* 知らせの都合で止めない */
    }
  });
}

export function notifyAdCovering(covering: boolean): void {
  listeners.forEach((l) => {
    try {
      l(covering);
    } catch {
      /* 音の都合で広告を止めない */
    }
  });
}
